//BB: DAshboard Reducer


import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Course {

    //teacher: string;
    teacher_id: string;
    course_id: string | null;
    course_name: string | null;
}

interface CourseState {
    courses: Course[];
    //course_id :string;
    // course_name :string;
    department_role_data: Course[]; 
    isLoading: boolean;
    // error: string | null;
}

const initialState: CourseState = {
    courses: [],
    isLoading: false,
    department_role_data: [], 
    //course_id: "", // Initialize as empty string instead of null
    //course_name: "", // Initialize as empty string instead of null

};


const courseListsDashboardSlice = createSlice({
    name: "courseListDashboard",
    initialState,
    reducers: {


        setCourseList: (state: CourseState, action: PayloadAction<{
                courses: Course[];
                department_role_data: Course[];
            }>) => {
            state.courses = action.payload.courses || [];
            state.department_role_data = action.payload.department_role_data || [];
            state.isLoading = false;
        },
        setLoading: (state: CourseState, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
            // state.error = null;
        },
        resetCourseList: () => {
            return initialState;
        },
    },
});

export const {
    setCourseList,
    setLoading,
    // seterror,
    // setPagination,
    resetCourseList
} = courseListsDashboardSlice.actions;

export default courseListsDashboardSlice.reducer;
